/** Do not edit this file, it is automatically generated **/
import React, { SVGAttributes } from "react";
import styled from "styled-components";

export interface IconProps extends SVGAttributes<SVGElement> {
  title?: string;
}

const _Icon: React.FC<IconProps> = ({ children, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
      {props.title && <title>{props.title}</title>}
      {children}
    </svg>
  );
};

const Icon = styled(_Icon)``;

export default Icon;
